<template>
  <div class="card-container">
    <img v-if="data.facade" :src="data.facade" :alt="data.name" style="display: block;">
    <div v-else class="box-exposition">
      <img src="/assets/images/sala-de-exposicion.png" :alt="data.name" class="img-exposition">
    </div>
    <div class="card-bottom">
      <h3>{{ data.name }}</h3>
      <div class="card-buttons-grid">
        <a v-if="data.has_brand_new_active_inventory == true" :href="'/nuevos'+vehiclesUrl">Nuevos</a>
        <a v-if="data.has_used_vehicle_active_inventory == true" :href="vehiclesUrl">Seminuevos</a>
        <a v-if="data.has_car_service == true" :href="whatsappMessage" target="_blank" class="car-service-button">Taller de Servicio</a>
      </div>
    </div>
  </div>
</template>

<script>
//   import FiltersComponent from "./FiltersComponent.vue";
//   import OrderbyComponent from "./OrderbyComponent.vue";
//   import TagsComponent from "./TagsComponent.vue";
  
  export default {
    props: {
      data: Object
    },
    computed: {
      whatsappMessage() {
        return `https://wa.me/52${this.data.meta_leads_car_service_whatsapp_phone}?text=${this.data.car_service_whatsapp_message ?? ''}`
      },
      vehiclesUrl() { 
        return `/catalogo?states=${this.data.state_id}&dealerships=${this.data.id}&orderby=1&page=1&size=24`;
      }
    }
  }
</script>

<style scoped>
  .card-container {
    display: flex; 
    flex-direction: column; 
    background-color: #fff;
    width: 100%;
    height: 360px;
  }
  img {
    width: 100%;
    height: 140px;
  }
  .card-bottom {
    justify-content: center;
    flex: 1 0;
    padding: 30px 0;
    display: flex; 
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  }
  
  .card-bottom > * {
    font-size: 18px;
    font-weight: 500;
  }

  .card-buttons-grid > a {
    text-align: center;
    background: #000;
    padding: 8px 16px;
    border-radius: 8px;
    color: #fff;
  }

  
  .card-buttons-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 0 4px;
    row-gap: 10px;
    column-gap: 5px;
  }

  .card-buttons-grid > a.car-service-button {
    justify-content: center;
    font-size: 13px;
    min-height: 39.7px;
    display: flex;
    align-items: center;
    padding: 8px 4px;
  }
  .box-exposition{
      display: flex;
      justify-content: center;
      height: 140px;
      align-items: center;
  }
  .img-exposition{
      display: flex;
      width: 100px;
      height: 100px;
  }
</style>